import InspectionSheet from "@/pages/inspections/sheet";
import InspectionsManager from "@/pages/inspections/manager";
import InspectionsReport from "@/pages/inspections/report";
import { PermissionRoute } from "./PermissionRoute";

export const routeInspectionsManager = "/inspections/manager";
export const routeInspectionsReport = "/inspections/report";
export const routeInspectionSheet = "/inspections/sheet";

export const inspectionRoutes = [
	{
		path: routeInspectionsManager,
		element: (
			<PermissionRoute permission="ui.navbar.inspections.manager">
				<InspectionsManager />
			</PermissionRoute>
		),
		permission: "ui.navbar.inspections.manager",
	},
	{
		path: `${routeInspectionsManager}/:shiftId`,
		element: (
			<PermissionRoute permission="ui.navbar.inspections.manager">
				<InspectionsManager />
			</PermissionRoute>
		),
		permission: "ui.navbar.inspections.manager",
	},
	{
		path: routeInspectionsReport,
		element: (
			<PermissionRoute permission="ui.navbar.inspections.report">
				<InspectionsReport />
			</PermissionRoute>
		),
		permission: "ui.navbar.inspections.report",
	},
	{
		path: `${routeInspectionSheet}/:inspectionId`,
		element: (
			<PermissionRoute permission="ui.navbar.inspections.manager">
				<InspectionSheet />
			</PermissionRoute>
		),
		permission: "ui.navbar.inspections.manager",
	},
];
